"use client";

import { useStrictLocalization } from "@faire/localization/react/useStrictLocalization";
import { IconButton } from "@faire/slate/components/icon-button";
import { Close } from "@faire/slate-icons/Close";
import { useModalContext } from "@faire/slate/private/modal/ModalContext";
import React from "react";

import { ModalCloseVariant } from "./types";

type IProps = {
  variant?: ModalCloseVariant;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

export const ModalClose: React.FC<IProps> = ({
  variant = "default",
  onClick,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const { closeModal } = useModalContext();

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    closeModal(e);
    onClick?.(e);
  };

  const closeText = strictLocalize({
    id: "e7UmTk",
    defaultMessage: "Close modal",
    description: {
      text: "alt text for screen reader for the close modal button",
    },
  });

  if (variant === "onColor") {
    return (
      <div className="fs-mode-on-surface">
        <IconButton
          Icon={Close}
          onClick={handleClick}
          variant="primary"
          size="xSmall"
          aria-label={closeText}
        />
      </div>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="fs-modal__close-btn interactive focusable"
      aria-label={closeText}
      type="button"
    >
      <Close titleAccess="" />
    </button>
  );
};
